import { useContext } from 'react'
import { RouterContext } from 'context/RouterContext'

const useRouter = () => {
  const { router } = useContext(RouterContext)
  return router
}

export default useRouter
